import { useNavigate } from "react-router-dom";
import ProductsForm from "components/products/ProductsForm";
import { useProducts } from "components/products/hooks/useProducts";
import Alert from "components/common/Alert";
import { useState, useRef, useEffect } from "react";

export default function CreateProduct() {
  const navigate = useNavigate();
  const { addProduct } = useProducts();

  const [alert, setAlert] = useState(null);

  const userId = "69579c6190a653b640e65639";
  const companyId = localStorage.getItem("company_id");
  const alertRef = useRef(null);

  useEffect(() => {
      if (alert && alertRef.current) {
        alertRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, [alert]);

  return (
    <>
      {alert && (
      <div ref={alertRef}>
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      </div>
      )}

      <ProductsForm
        onSubmit={async (fd) => {
          try {
            fd.append("company_id", companyId);
            fd.append("created_by", userId);

            await addProduct(fd);  
            navigate("/admin/products");
          } catch (error) {
            setAlert({
              type: "error",
              message:
                error.response?.data?.message ||
                "Failed to create product",
            });
          }
        }}
        onBack={() => navigate("/admin/products")}
      />
    </>
  );
}
